export const getReachabilityName = (status) => {
  switch (status) {
    case 'reachable':
      return 'Reachable';
    case 'maintenance':
      return 'Maintenance';
    case 'unreachable':
      return 'Unreachable';
    default:
      return 'N/A';
  }
};

export const getCreditScoreText = (creditScore) => {
  switch (creditScore) {
    case 'Poor':
      return 'Poor';
    case 'Good':
      return 'Good';
    case 'Excellent':
      return 'Excellent';
    default:
      return 'N/A';
  }
};
